
























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {
  }
})
export default class CardComponent extends Vue {
  
  @Prop({ default: '',  type: String}) title!: string;
  @Prop({ default: '',  type: String}) icon!: string;
  @Prop({ default: '',  type: String}) headerIcon!: string;
  @Prop({ default: '',  type: String}) headerIconText!: string;
  @Prop({ default: 'left',  type: String}) footerAlign!: string;
  
  headerIconClick() {
    this.$emit('header-icon-click');
  }
}
